import styled from 'styled-components';
import { breakpoints, colors, fonts, pxToCssFont } from '@vfit/shared/themes';

export const ExternalContainer = styled.div`
  position: relative;
  height: 786px;
  max-width: 100%;
  border-radius: 15px;
  margin: 0 auto;
  background: lightgray -559.748px -0.989px / 530.809% 142.365% no-repeat;
  @media (min-width: ${breakpoints.tablet}) {
    height: 728px;
  }
  @media (min-width: ${breakpoints.desktop}) {
    height: 797px;
    width: 1280px;
    background: lightgray -90.989px -7.584px / 134.803% 121.78% no-repeat;
  }
`;

export const ImageContainer = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 15px;
`;

export const Title = styled.header`
  font-family: ${fonts.exbold};
  color: ${colors.$ffffff};
  ${pxToCssFont(28, 36)};
  z-index: 2;
  text-align: center;

  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(36, 48)};
  }
`;

export const Description = styled.p`
  font-family: ${fonts.regular};
  color: ${colors.$ffffff};
  margin: 12px 25px;
  text-align: center;
  z-index: 2;
  ${pxToCssFont(18, 24)};
  @media (min-width: ${breakpoints.desktop}) {
    ${pxToCssFont(22, 32)};
    margin-top: 12px;
  }
`;

export const ButtonContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 56px;
  z-index: 2;
  text-align: center;
  button {
    width: 200px;
  }
`;
